import styled from 'styled-components';
import variables from '../../../styles/variables';
import Image from '../../UI/Image/Image';

export const Banner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 10px;
  max-width: 100%;
  width: 100%;
  height: auto;
  align-self: stretch;
  position: relative;
  margin: 0 auto;
  border-radius: 15px;
  background-color: #fff;
  text-decoration: none;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 8px 0px;
  overflow: hidden;

  &.hero-carousel {
    border: none;
    border-radius: 0;
    background-color: ${variables.colorBlackAlt};
  }

  &.plan-carousel {
    margin-top: 10px;
  }

  h3 {
    font-size: 1.6rem;
    line-height: 1.38;
    margin-bottom: 0.8rem;
  }

  p {
    text-align: left;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: flex-end;
  width: 100.5%;

  &.hero-carousel {
    @media screen and (max-width: 640px) {
      justify-content: center;
    }

    .gatsby-image-wrapper {
      img {
        height: 100.5%;
      }
    }
  }
`;

export const DesktopPromoImage = styled(Image)`
  display: block !important;
  grid-area: 1/1;

  @media screen and (max-width: 1024px) {
    display: none !important;
  }
`;

export const TabletPromoImage = styled(Image)`
  display: none !important;
  grid-area: 1/1;

  @media screen and (max-width: 1024px) {
    display: block !important;
  }

  @media screen and (max-width: 640px) {
    display: none !important;
  }
`;

export const MobilePromoImage = styled(Image)`
  display: none !important;
  grid-area: 1/1;

  @media screen and (max-width: 640px) {
    display: block !important;
  }
`;

export const ContentContainer = styled.div`
  position: relative;
  padding: 33px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 640px) {
    padding: 18px;
  }

  &.accessory-promo-large {
    flex-direction: row;
    justify-content: space-between;

    @media screen and (max-width: 1024px) {
      flex-direction: column;
    }

    p {
      margin-bottom: 0;

      @media screen and (max-width: 1024px) {
        margin-bottom: 1rem;
      }
    }
  }
`;

export const CopyContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  p {
    font-size: 26px;
    line-height: 26px;
    font-weight: 500;

    @media screen and (max-width: 1024px) {
      font-size: 22px;
      line-height: 22px;
    }

    @media screen and (max-width: 640px) {
      font-size: 18px;
      line-height: 18px;
    }
  }
`;

export const CtaContainer = styled.div`
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: flex-start;

  &.accessory-promo-large {
    flex-direction: flex-end;
    justify-content: flex-end;
    align-items: center;
    margin: 0;

    @media screen and (max-width: 1024px) {
      width: 100%;
      flex-direction: flex-start;
      justify-content: flex-start;
    }
  }
`;
